"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeSelection = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var vektorio_1 = require("@caddigital/sok-types/lib/vektorio");
var dispatchers_1 = require("./utils/dispatchers");
var getState = function (state) { return state.vektorio.linkFolders; };
var ModeSelection = function () {
    var state = (0, react_redux_1.useSelector)(getState);
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var isRootSelected = state.mode == vektorio_1.ROOT;
    var isPathSelected = state.mode == vektorio_1.PATH;
    return (React.createElement("div", { className: 'path-selection' },
        React.createElement(sok_ui_1.Input, { type: 'radio', value: isRootSelected, onChange: dispatchers.setMode(vektorio_1.ROOT), label: (0, translation_1.getLocalization)('vektorio/root') }),
        React.createElement(sok_ui_1.Input, { type: 'radio', value: isPathSelected, onChange: dispatchers.setMode(vektorio_1.PATH), label: (0, translation_1.getLocalization)('vektorio/path') })));
};
exports.ModeSelection = ModeSelection;
